export default "__VITE_ASSET__CWa$gi9n__"